// source: fundRatesMsg.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

goog.exportSymbol('proto.FundRatesPbMsg', null, global);
goog.exportSymbol('proto.FundRatesPbMsg.Body', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.FundRatesPbMsg = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.FundRatesPbMsg.repeatedFields_, null);
};
goog.inherits(proto.FundRatesPbMsg, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.FundRatesPbMsg.displayName = 'proto.FundRatesPbMsg';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.FundRatesPbMsg.Body = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.FundRatesPbMsg.Body, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.FundRatesPbMsg.Body.displayName = 'proto.FundRatesPbMsg.Body';
}

/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.FundRatesPbMsg.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.FundRatesPbMsg.prototype.toObject = function(opt_includeInstance) {
  return proto.FundRatesPbMsg.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.FundRatesPbMsg} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.FundRatesPbMsg.toObject = function(includeInstance, msg) {
  var f, obj = {
    fundratesList: jspb.Message.toObjectList(msg.getFundratesList(),
    proto.FundRatesPbMsg.Body.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.FundRatesPbMsg}
 */
proto.FundRatesPbMsg.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.FundRatesPbMsg;
  return proto.FundRatesPbMsg.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.FundRatesPbMsg} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.FundRatesPbMsg}
 */
proto.FundRatesPbMsg.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.FundRatesPbMsg.Body;
      reader.readMessage(value,proto.FundRatesPbMsg.Body.deserializeBinaryFromReader);
      msg.addFundrates(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.FundRatesPbMsg.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.FundRatesPbMsg.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.FundRatesPbMsg} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.FundRatesPbMsg.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFundratesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.FundRatesPbMsg.Body.serializeBinaryToWriter
    );
  }
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.FundRatesPbMsg.Body.prototype.toObject = function(opt_includeInstance) {
  return proto.FundRatesPbMsg.Body.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.FundRatesPbMsg.Body} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.FundRatesPbMsg.Body.toObject = function(includeInstance, msg) {
  var f, obj = {
    contractcode: jspb.Message.getFieldWithDefault(msg, 1, ""),
    markprice: jspb.Message.getFieldWithDefault(msg, 2, ""),
    indexprice: jspb.Message.getFieldWithDefault(msg, 3, ""),
    feerate: jspb.Message.getFieldWithDefault(msg, 4, ""),
    estimatefeerate: jspb.Message.getFieldWithDefault(msg, 5, ""),
    nextliquidationinterval: jspb.Message.getFieldWithDefault(msg, 6, 0),
    totalposition: jspb.Message.getFieldWithDefault(msg, 7, ""),
    indexcny: jspb.Message.getFieldWithDefault(msg, 8, ""),
    markcny: jspb.Message.getFieldWithDefault(msg, 9, ""),
    env: jspb.Message.getFieldWithDefault(msg, 10, 0),
    base: jspb.Message.getFieldWithDefault(msg, 11, ""),
    indexbase: jspb.Message.getFieldWithDefault(msg, 12, ""),
    quote: jspb.Message.getFieldWithDefault(msg, 13, ""),
    basedisplayname: jspb.Message.getFieldWithDefault(msg, 14, ""),
    indexbasedisplayname: jspb.Message.getFieldWithDefault(msg, 15, ""),
    quotedisplayname: jspb.Message.getFieldWithDefault(msg, 16, ""),
    predeliveryprice: jspb.Message.getFieldWithDefault(msg, 17, ""),
    online: jspb.Message.getFieldWithDefault(msg, 18, 0),
    lastprice: jspb.Message.getFieldWithDefault(msg, 19, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.FundRatesPbMsg.Body}
 */
proto.FundRatesPbMsg.Body.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.FundRatesPbMsg.Body;
  return proto.FundRatesPbMsg.Body.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.FundRatesPbMsg.Body} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.FundRatesPbMsg.Body}
 */
proto.FundRatesPbMsg.Body.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setContractcode(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setMarkprice(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setIndexprice(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setFeerate(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setEstimatefeerate(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setNextliquidationinterval(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setTotalposition(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setIndexcny(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setMarkcny(value);
      break;
    case 10:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setEnv(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setBase(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setIndexbase(value);
      break;
    case 13:
      var value = /** @type {string} */ (reader.readString());
      msg.setQuote(value);
      break;
    case 14:
      var value = /** @type {string} */ (reader.readString());
      msg.setBasedisplayname(value);
      break;
    case 15:
      var value = /** @type {string} */ (reader.readString());
      msg.setIndexbasedisplayname(value);
      break;
    case 16:
      var value = /** @type {string} */ (reader.readString());
      msg.setQuotedisplayname(value);
      break;
    case 17:
      var value = /** @type {string} */ (reader.readString());
      msg.setPredeliveryprice(value);
      break;
    case 18:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setOnline(value);
      break;
    case 19:
      var value = /** @type {string} */ (reader.readString());
      msg.setLastprice(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.FundRatesPbMsg.Body.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.FundRatesPbMsg.Body.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.FundRatesPbMsg.Body} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.FundRatesPbMsg.Body.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getContractcode();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getMarkprice();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getIndexprice();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getFeerate();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getEstimatefeerate();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getNextliquidationinterval();
  if (f !== 0) {
    writer.writeInt64(
      6,
      f
    );
  }
  f = message.getTotalposition();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getIndexcny();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getMarkcny();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getEnv();
  if (f !== 0) {
    writer.writeInt32(
      10,
      f
    );
  }
  f = message.getBase();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
  f = message.getIndexbase();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
  f = message.getQuote();
  if (f.length > 0) {
    writer.writeString(
      13,
      f
    );
  }
  f = message.getBasedisplayname();
  if (f.length > 0) {
    writer.writeString(
      14,
      f
    );
  }
  f = message.getIndexbasedisplayname();
  if (f.length > 0) {
    writer.writeString(
      15,
      f
    );
  }
  f = message.getQuotedisplayname();
  if (f.length > 0) {
    writer.writeString(
      16,
      f
    );
  }
  f = message.getPredeliveryprice();
  if (f.length > 0) {
    writer.writeString(
      17,
      f
    );
  }
  f = message.getOnline();
  if (f !== 0) {
    writer.writeInt32(
      18,
      f
    );
  }
  f = message.getLastprice();
  if (f.length > 0) {
    writer.writeString(
      19,
      f
    );
  }
};


/**
 * optional string contractCode = 1;
 * @return {string}
 */
proto.FundRatesPbMsg.Body.prototype.getContractcode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.FundRatesPbMsg.Body} returns this
 */
proto.FundRatesPbMsg.Body.prototype.setContractcode = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string markPrice = 2;
 * @return {string}
 */
proto.FundRatesPbMsg.Body.prototype.getMarkprice = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.FundRatesPbMsg.Body} returns this
 */
proto.FundRatesPbMsg.Body.prototype.setMarkprice = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string indexPrice = 3;
 * @return {string}
 */
proto.FundRatesPbMsg.Body.prototype.getIndexprice = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.FundRatesPbMsg.Body} returns this
 */
proto.FundRatesPbMsg.Body.prototype.setIndexprice = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string feeRate = 4;
 * @return {string}
 */
proto.FundRatesPbMsg.Body.prototype.getFeerate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.FundRatesPbMsg.Body} returns this
 */
proto.FundRatesPbMsg.Body.prototype.setFeerate = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string estimateFeeRate = 5;
 * @return {string}
 */
proto.FundRatesPbMsg.Body.prototype.getEstimatefeerate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.FundRatesPbMsg.Body} returns this
 */
proto.FundRatesPbMsg.Body.prototype.setEstimatefeerate = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional int64 nextLiquidationInterval = 6;
 * @return {number}
 */
proto.FundRatesPbMsg.Body.prototype.getNextliquidationinterval = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.FundRatesPbMsg.Body} returns this
 */
proto.FundRatesPbMsg.Body.prototype.setNextliquidationinterval = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional string totalPosition = 7;
 * @return {string}
 */
proto.FundRatesPbMsg.Body.prototype.getTotalposition = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.FundRatesPbMsg.Body} returns this
 */
proto.FundRatesPbMsg.Body.prototype.setTotalposition = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string indexCny = 8;
 * @return {string}
 */
proto.FundRatesPbMsg.Body.prototype.getIndexcny = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.FundRatesPbMsg.Body} returns this
 */
proto.FundRatesPbMsg.Body.prototype.setIndexcny = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional string markCny = 9;
 * @return {string}
 */
proto.FundRatesPbMsg.Body.prototype.getMarkcny = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.FundRatesPbMsg.Body} returns this
 */
proto.FundRatesPbMsg.Body.prototype.setMarkcny = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional int32 env = 10;
 * @return {number}
 */
proto.FundRatesPbMsg.Body.prototype.getEnv = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/**
 * @param {number} value
 * @return {!proto.FundRatesPbMsg.Body} returns this
 */
proto.FundRatesPbMsg.Body.prototype.setEnv = function(value) {
  return jspb.Message.setProto3IntField(this, 10, value);
};


/**
 * optional string base = 11;
 * @return {string}
 */
proto.FundRatesPbMsg.Body.prototype.getBase = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/**
 * @param {string} value
 * @return {!proto.FundRatesPbMsg.Body} returns this
 */
proto.FundRatesPbMsg.Body.prototype.setBase = function(value) {
  return jspb.Message.setProto3StringField(this, 11, value);
};


/**
 * optional string indexBase = 12;
 * @return {string}
 */
proto.FundRatesPbMsg.Body.prototype.getIndexbase = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/**
 * @param {string} value
 * @return {!proto.FundRatesPbMsg.Body} returns this
 */
proto.FundRatesPbMsg.Body.prototype.setIndexbase = function(value) {
  return jspb.Message.setProto3StringField(this, 12, value);
};


/**
 * optional string quote = 13;
 * @return {string}
 */
proto.FundRatesPbMsg.Body.prototype.getQuote = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 13, ""));
};


/**
 * @param {string} value
 * @return {!proto.FundRatesPbMsg.Body} returns this
 */
proto.FundRatesPbMsg.Body.prototype.setQuote = function(value) {
  return jspb.Message.setProto3StringField(this, 13, value);
};


/**
 * optional string baseDisplayName = 14;
 * @return {string}
 */
proto.FundRatesPbMsg.Body.prototype.getBasedisplayname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 14, ""));
};


/**
 * @param {string} value
 * @return {!proto.FundRatesPbMsg.Body} returns this
 */
proto.FundRatesPbMsg.Body.prototype.setBasedisplayname = function(value) {
  return jspb.Message.setProto3StringField(this, 14, value);
};


/**
 * optional string indexBaseDisplayName = 15;
 * @return {string}
 */
proto.FundRatesPbMsg.Body.prototype.getIndexbasedisplayname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 15, ""));
};


/**
 * @param {string} value
 * @return {!proto.FundRatesPbMsg.Body} returns this
 */
proto.FundRatesPbMsg.Body.prototype.setIndexbasedisplayname = function(value) {
  return jspb.Message.setProto3StringField(this, 15, value);
};


/**
 * optional string quoteDisplayName = 16;
 * @return {string}
 */
proto.FundRatesPbMsg.Body.prototype.getQuotedisplayname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 16, ""));
};


/**
 * @param {string} value
 * @return {!proto.FundRatesPbMsg.Body} returns this
 */
proto.FundRatesPbMsg.Body.prototype.setQuotedisplayname = function(value) {
  return jspb.Message.setProto3StringField(this, 16, value);
};


/**
 * optional string preDeliveryPrice = 17;
 * @return {string}
 */
proto.FundRatesPbMsg.Body.prototype.getPredeliveryprice = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 17, ""));
};


/**
 * @param {string} value
 * @return {!proto.FundRatesPbMsg.Body} returns this
 */
proto.FundRatesPbMsg.Body.prototype.setPredeliveryprice = function(value) {
  return jspb.Message.setProto3StringField(this, 17, value);
};


/**
 * optional int32 online = 18;
 * @return {number}
 */
proto.FundRatesPbMsg.Body.prototype.getOnline = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 18, 0));
};


/**
 * @param {number} value
 * @return {!proto.FundRatesPbMsg.Body} returns this
 */
proto.FundRatesPbMsg.Body.prototype.setOnline = function(value) {
  return jspb.Message.setProto3IntField(this, 18, value);
};


/**
 * optional string lastPrice = 19;
 * @return {string}
 */
proto.FundRatesPbMsg.Body.prototype.getLastprice = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 19, ""));
};


/**
 * @param {string} value
 * @return {!proto.FundRatesPbMsg.Body} returns this
 */
proto.FundRatesPbMsg.Body.prototype.setLastprice = function(value) {
  return jspb.Message.setProto3StringField(this, 19, value);
};


/**
 * repeated Body fundRates = 1;
 * @return {!Array<!proto.FundRatesPbMsg.Body>}
 */
proto.FundRatesPbMsg.prototype.getFundratesList = function() {
  return /** @type{!Array<!proto.FundRatesPbMsg.Body>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.FundRatesPbMsg.Body, 1));
};


/**
 * @param {!Array<!proto.FundRatesPbMsg.Body>} value
 * @return {!proto.FundRatesPbMsg} returns this
*/
proto.FundRatesPbMsg.prototype.setFundratesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.FundRatesPbMsg.Body=} opt_value
 * @param {number=} opt_index
 * @return {!proto.FundRatesPbMsg.Body}
 */
proto.FundRatesPbMsg.prototype.addFundrates = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.FundRatesPbMsg.Body, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.FundRatesPbMsg} returns this
 */
proto.FundRatesPbMsg.prototype.clearFundratesList = function() {
  return this.setFundratesList([]);
};


goog.object.extend(exports, proto);
